import { createContext, useState } from "react";

import { Dlog } from "./../../../utils/Dlog";

const RefresherContext = createContext({
  requiresRefresh: false,
  triggerUpdate: () => {}
});

export const RefresherProvider = props => {
  const triggerUpdate = () => {
    Dlog("RefresherProvider IssueSMU triggerUpdate", state);
    setState({ ...state, requiresRefresh: !state.requiresRefresh });
  };

  const initState = {
    requiresRefresh: false,
    triggerUpdate: triggerUpdate
  };

  const [state, setState] = useState(initState);

  return (
    <RefresherContext.Provider value={state}>
      {props.children}
    </RefresherContext.Provider>
  );
};

export const RefresherConsumer = RefresherContext.Consumer;
export default RefresherContext;
